import React from "react";
import { RelativeCenter } from "../../../../../layout/RelativeCenter/RelativeCenter";
import { Spacing } from "../../../../../layout/Spacing/Spacing";
import { SpacingCustom } from "../../../../../layout/Spacing/SpacingCustom";
import { Loader } from "../../../../../shared/Loader/Loader";
import { TextCustom } from "../../../../../ui/TextCustom";
import { Modal } from "../../../../Modal/Modal";
import { KnowladgeGraphDiffTable } from "../KnowladgeGraphDiffTable/KnowladgeGraphDiffTable";
import { useAppSelector } from "../../../../../../redux/hooks";
import { rootState } from "../../../../../../redux/store";

export const AiAnalyzerDiffTableModal: React.FC = () => {
    const { knowladgeGraphDiffLoading } = useAppSelector((state: rootState) => state.knowladgeGraphDiff);
    const { selectedKnowledgeFile } = useAppSelector((state: rootState) => state.knowledgeFile);
    
    return (
        <Modal modalKey="aiAnalyzerTableModal">
            {knowladgeGraphDiffLoading ? (
                    <RelativeCenter>
                        <Spacing marginSpacing={'none'} paddingSpacing={'l'}>
                            <Loader width={30} height={30} color="accent-green" label="Getting table differences" gap={1} />
                        </Spacing>
                    </RelativeCenter>
                ) : (
                    <>
                        <SpacingCustom paddingTop={2.4}>
                            <div style={{ width: '100%', minHeight: '300px' }}>
                                <SpacingCustom paddingBottom={0.5} paddingLeft={0.5}>
                                    <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '1rem' }}>
                                        <TextCustom weight={600} color="dark">
                                            File name:{' '}
                                        </TextCustom>
                                        <Spacing marginSpacing="s" paddingSpacing="s">
                                            <TextCustom color="dark">{selectedKnowledgeFile}</TextCustom>
                                        </Spacing>
                                    </div>
                                </SpacingCustom>
                                <KnowladgeGraphDiffTable selectedKnowledgeFile={selectedKnowledgeFile} />
                            </div>
                        </SpacingCustom>
                    </>
                )}
        </Modal>
    )
}